import { useUrlGenerator } from '@folklore/routes';
import { useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { useCallback } from 'react';
import { useLocation, useSearch } from 'wouter';

import { useMenus } from '../../../contexts/SiteContext';
import OrderForm from '../../forms/Order';
import PageMeta from '../../partials/PageMeta';
import Sidebar from '../../partials/Sidebar';

import styles from '../../../../styles/pages/pro.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function OrderCreatePage({ page = null }) {
    const { pro } = useMenus();
    const route = useUrlGenerator();
    const [, setLocation] = useLocation();
    const queryClient = useQueryClient();
    const search = useSearch();
    const { film = null } = queryString.parse(search || '');
    const { title = null, action = null, fields = null } = page || {};

    const onComplete = useCallback(
        (data) => {
            queryClient.invalidateQueries({ queryKey: ['orders'] });
            const { id: orderId = null, paid = false } = data || {};
            if (orderId != null && !paid) {
                setLocation(`${route('pro.order.payment', { order: orderId })}?saved=1`);
            } else {
                setLocation(`${route('pro.orders')}?saved=1`);
            }
        },
        [route, setLocation],
    );

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Sidebar className={styles.sidebar} menu={pro} title={title}>
                <OrderForm
                    className={styles.form}
                    action={action}
                    fields={fields}
                    onComplete={onComplete}
                    value={film !== null ? { films: [film] } : null}
                    isCreate
                />
            </Sidebar>
        </div>
    );
}

OrderCreatePage.propTypes = propTypes;

export default OrderCreatePage;
